import React from 'react';
import DialogList from 'src/dialogs';
import Dialog from '../common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

const DocumentViewer = () => {
    const handleButton = () => {
        window.alert('wtf');
    };

    return (
        <>
            <Dialog title="Document Viewer" dialogName={DialogList.DOCUMENT_VIEWER}>
                <div>
                    <label>hi</label>

                    <Button text="test" onClick={() => handleButton} />
                </div>
            </Dialog>
        </>
    );
};

export default DocumentViewer;



// WEBPACK FOOTER //
// ./src/components/layout/DocumentViewer.tsx